export default __webpack_public_path__ + "static/media/avatar_cheshire_cat8.f4d3a9b7.mp3";